import React from "react";
import { Chart, Interval, Tooltip, Axis, Coord } from "bizcharts";
import { Empty } from "antd";

const ChargebackIssuer = ({ t, data, showAll }) => {
  // const data = [
  //   { bank_name: "Bank of America", total: 1 },
  //   { bank_name: "Chase Bank", total: 2 },
  //   { bank_name: "Wells Fargo", total: 3 },
  //   { bank_name: "Citibank", total: 4 },
  //   { bank_name: "HSBC", total: 5 },
  //   { bank_name: "Barclays", total: 6 },
  //   { bank_name: "Deutsche Bank", total: 7 },
  //   { bank_name: "BNP Paribas", total: 8 },
  //   { bank_name: "UBS", total: 9 },
  //   { bank_name: "Credit Suisse", total: 10 },
  //   { bank_name: "Goldman Sachs", total: 11 },
  //   { bank_name: "Morgan Stanley", total: 12 },
  //   { bank_name: "Standard Chartered", total: 13 },
  // ];

  if (!data?.length) {
    return <Empty />;
  }

  const filteredData = showAll ? data : data.filter((item) => item.total <= 10);
  const displayedData = [...filteredData].sort((a, b) => a.total - b.total);

  return (
    <div>
      {data.length ? (
        <div
          style={{
            maxHeight: showAll ? 450 : 350,
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          <Chart
            height={showAll ? 50 * displayedData.length : 350}
            autoFit
            data={displayedData}
            padding={[30, 30, 30, 250]}
          >
            <Coord transpose />
            <Axis
              name="bank_name"
              label={{
                style: {
                  fontSize: 14,
                  fill: "#192B56",
                },
              }}
            />
            <Axis
              name="total"
              tickInterval={1}
              label={{
                formatter: (val) => (val % 1 === 0 ? val.toString() : ""),
              }}
            />
            <Tooltip shared />
            <Interval position="bank_name*total" />
          </Chart>
        </div>
      ) : (
        <Empty />
      )}
    </div>
  );
};

export default ChargebackIssuer;
